import { render } from "./MemoruAlbum.vue?vue&type=template&id=592decb1&scoped=true&ts=true"
import script from "./MemoruAlbum.vue?vue&type=script&lang=ts"
export * from "./MemoruAlbum.vue?vue&type=script&lang=ts"

import "./MemoruAlbum.vue?vue&type=style&index=0&id=592decb1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592decb1"]])

export default __exports__